module.exports = __webpack_public_path__ + "media/images/profile/astrology-info-b6b85ff968165296c67912cc1db6c126.svg";